
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";

const About = () => {
  return (
    <section id="about" className="py-16 bg-gray-50 dark:bg-fraudeye-secondary">
      <div className="container px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-12 items-center">
          <div className="flex-1 space-y-4">
            <h2 className="text-3xl font-bold tracking-tight">Why FraudEye?</h2>
            <p className="text-muted-foreground">
              In a world of increasingly sophisticated AI-based fraud, we are committed to:
            </p>
            <ul className="space-y-2">
              <li className="flex items-start gap-2">
                <CheckCircle2 className="h-5 w-5 text-fraudeye-accent mt-0.5" />
                <span>Transparent and accurate fraud detection algorithms</span>
              </li>
              <li className="flex items-start gap-2">
                <CheckCircle2 className="h-5 w-5 text-fraudeye-accent mt-0.5" />
                <span>Continuous improvement of detection accuracy</span>
              </li>
              <li className="flex items-start gap-2">
                <CheckCircle2 className="h-5 w-5 text-fraudeye-accent mt-0.5" />
                <span>Privacy-focused analysis without unnecessary data collection</span>
              </li>
              <li className="flex items-start gap-2">
                <CheckCircle2 className="h-5 w-5 text-fraudeye-accent mt-0.5" />
                <span>Advanced tools for content authenticity verification</span>
              </li>
            </ul>
            <Button asChild className="mt-2 bg-fraudeye-accent hover:bg-fraudeye-highlight">
              <Link to="/contact">Contact Our Team</Link>
            </Button>
          </div>
          <div className="flex-1">
            <div className="rounded-xl overflow-hidden bg-white dark:bg-fraudeye-primary shadow-lg p-6 border">
              <h3 className="text-xl font-bold mb-4">Our Mission</h3>
              <p className="text-muted-foreground mb-6">
                To create accessible, powerful, and effective tools that help individuals and organizations detect and mitigate fraudulent content in the age of AI-generated media.
              </p>
              <div className="bg-muted rounded-lg p-4">
                <p className="italic text-sm">
                  "As AI technology advances, so must our tools to distinguish authentic from fraudulent content. Only through continuous innovation can we build a trustworthy digital ecosystem."
                </p>
                <p className="text-right mt-2 text-sm font-medium">- The FraudEye Team</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
